export default __webpack_public_path__ + "static/media/rosey2.b71ad181.png";